<script setup lang="ts">
const content = {
  title: '404',
  description: 'Pagina niet gevonden',
  message: 'Helaas, deze pagina bestaat niet.',
  hint: 'Klik hierboven op de pagina die je wilt bezoeken. Heb je vragen? Dan kan je naar de contactpagina gaan. Dan helpen wij graag verder.',
}

useSeoMeta({
  title: content.title,
  ogTitle: content.title,
  description: content.description,
  ogDescription: content.description,
})
</script>

<template>
  <UApp>
    <NavHeader />

    <UMain class="mt-12">
      <UContainer>
        <UPageHeader
          :title="content.title"
          :description="content.description"
        />
        <UPage>
          <UPageBody class="prose">
            <h2>{{ content.message }}</h2>
            <p>{{ content.hint }}</p>
          </UPageBody>

          <template #right>
            <div class="mt-12 relative">
              <SidebarCompareAgents class="static" />
            </div>
          </template>
        </UPage>
      </UContainer>
    </UMain>

    <NavFooter />
  </UApp>
</template>
